// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/4aea527b4f0951f03f0f.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"989237ffb6a1782bf385","119":"bf2f6b283255680ca01f","120":"aefcdfb46bc8c1028948"}[chunkId] + ".chunk.js";
};